module.exports = __webpack_public_path__ + "static/logo-vector-9fc07161f530d744b9c001f31c610a64.svg";